import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

const AVATAR_COLORS = ['#2563eb','#7c3aed','#059669','#d97706','#dc2626','#0891b2','#be185d'];
const avatarColor = (str) => AVATAR_COLORS[(str || '?').charCodeAt(0) % AVATAR_COLORS.length];
const initials = (nombres, apellidos) => {
  const n = (nombres || '').trim()[0] || '';
  const a = (apellidos || '').trim()[0] || '';
  return (n + a).toUpperCase() || '?';
};
const tiempoRelativo = (fecha) => {
  if (!fecha) return '';
  const diff = (Date.now() - new Date(fecha)) / 1000;
  if (diff < 60) return 'ahora';
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return new Date(fecha).toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit' });
};

const CrmPipelineCard = ({ prospecto, onSelect, isSelected, isDragOverlay = false }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: String(prospecto.id),
    disabled: isDragOverlay,
  });

  const ini = initials(prospecto.nombres, prospecto.apellidos);
  const color = avatarColor(prospecto.nombres);
  const nombre = `${prospecto.nombres}${prospecto.apellidos ? ' ' + prospecto.apellidos : ''}`;
  const tiempo = tiempoRelativo(prospecto.ultimo_mensaje_fecha || prospecto.updated_at);
  const preview = prospecto.ultimo_mensaje
    ? prospecto.ultimo_mensaje
        .replace(/^📱\s*(Primer contacto WA|Mensaje WA):\s*"?/, '')
        .replace(/"$/, '')
        .slice(0, 48)
    : prospecto.whatsapp_number || '';

  const style = transform ? { transform: CSS.Translate.toString(transform) } : undefined;

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        opacity: isDragging ? 0.35 : 1,
        background: isSelected ? '#eff6ff' : 'white',
        border: `1.5px solid ${isSelected ? '#2563eb' : '#e5e7eb'}`,
        borderRadius: '10px',
        padding: '0.75rem',
        cursor: isDragOverlay ? 'grabbing' : isDragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        boxShadow: isDragOverlay
          ? '0 10px 30px rgba(0,0,0,0.18)'
          : isDragging ? 'none' : '0 1px 3px rgba(0,0,0,0.06)',
        marginBottom: '0.5rem',
        transition: isDragging || isDragOverlay ? 'none' : 'box-shadow 0.15s',
        position: 'relative',
        zIndex: isDragOverlay ? 9999 : 'auto',
      }}
      {...(!isDragOverlay ? { ...listeners, ...attributes } : {})}
      onClick={() => !isDragging && onSelect(prospecto.id)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
        {/* Avatar */}
        <div style={{
          width: '34px', height: '34px', flexShrink: 0,
          borderRadius: '50%', background: color, color: 'white',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: '700', fontSize: '0.8rem',
        }}>
          {ini}
        </div>

        {/* Info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.15rem' }}>
            <span style={{
              fontWeight: '700', fontSize: '0.82rem', color: '#111827',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {nombre}
            </span>
            <span style={{ fontSize: '0.65rem', color: '#9ca3af', flexShrink: 0, marginLeft: '0.3rem' }}>
              {tiempo}
            </span>
          </div>

          {preview && (
            <p style={{
              margin: '0 0 0.3rem', fontSize: '0.74rem', color: '#6b7280',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {preview}
            </p>
          )}

          <span style={{
            fontSize: '0.6rem',
            background: prospecto.es_cliente ? '#d1fae5' : '#fef3c7',
            color: prospecto.es_cliente ? '#065f46' : '#92400e',
            border: prospecto.es_cliente ? 'none' : '1px solid #f59e0b',
            borderRadius: '4px', padding: '0.1rem 0.3rem', fontWeight: '700',
          }}>
            {prospecto.es_cliente ? 'cliente' : 'prospecto'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CrmPipelineCard;
